const moduleNameKey = "multipleTextValues";

export const multipleTextValuesEn = {
  [moduleNameKey]: {
    entriesLabel: "Entries",
    entryLabel: "Entry {{ index }}",
    entryLabelPlaceholder: "Enter label",
    nodeLabel: "Node {{ index }}",
    unitLabel: "Unit {{ index }}",
    addEntry: "Add entry",
    removeEntry: "Remove entry {{ index }}",
    nodeRequired: "Pick a node for every entry",
    labelRequired: "Every entry needs a label",
    machineLabel: "Machine",
    noMachines: "No machines found",
    machinesPlaceholder: "Search machines...",
    noNodes: "No nodes found",
    nodesPlaceholder: "Search nodes...",
    noUnits: "No units found",
    unitsPlaceholder: "Search units...",
    customColorsCheckbox: "Use custom colors",
    labelColorLabel: "Label color",
    valueColorLabel: "Value color",
    scaleInvalid: "Scaling factor must be a number",
    lookbackRequired: "Pick a lookback",
    saveButton: "Save",
    cancelButton: "Cancel",
  },
};

export const multipleTextValuesDe = {
  [moduleNameKey]: {
    entriesLabel: "Einträge",
    entryLabel: "Eintrag {{ index }}",
    entryLabelPlaceholder: "Bezeichnung eingeben",
    nodeLabel: "Knoten {{ index }}",
    unitLabel: "Einheit {{ index }}",
    addEntry: "Eintrag hinzufügen",
    removeEntry: "Eintrag {{ index }} entfernen",
    nodeRequired: "Für jeden Eintrag einen Knoten wählen",
    labelRequired: "Jeder Eintrag braucht eine Bezeichnung",
    machineLabel: "Maschine",
    noMachines: "Keine Maschinen gefunden",
    machinesPlaceholder: "Maschinen suchen...",
    noNodes: "Keine Knoten gefunden",
    nodesPlaceholder: "Knoten suchen...",
    noUnits: "Keine Einheiten gefunden",
    unitsPlaceholder: "Einheiten suchen...",
    customColorsCheckbox: "Eigene Farben verwenden",
    labelColorLabel: "Beschriftungsfarbe",
    valueColorLabel: "Wertfarbe",
    scaleInvalid: "Der Skalierungsfaktor muss eine Zahl sein",
    lookbackRequired: "Rückblick auswählen",
    saveButton: "Speichern",
    cancelButton: "Abbrechen",
  },
};

export const multipleTextValuesPtBr = {
  [moduleNameKey]: {
    entriesLabel: "Entradas",
    entryLabel: "Entrada {{ index }}",
    entryLabelPlaceholder: "Insira o rótulo",
    nodeLabel: "Nó {{ index }}",
    unitLabel: "Unidade {{ index }}",
    addEntry: "Adicionar entrada",
    removeEntry: "Remover entrada {{ index }}",
    nodeRequired: "Selecione um nó para cada entrada",
    labelRequired: "Toda entrada precisa de um rótulo",
    machineLabel: "Máquina",
    noMachines: "Nenhuma máquina encontrada",
    machinesPlaceholder: "Buscar máquinas...",
    noNodes: "Nenhum nó encontrado",
    nodesPlaceholder: "Buscar nós...",
    noUnits: "Nenhuma unidade encontrada",
    unitsPlaceholder: "Buscar unidades...",
    customColorsCheckbox: "Usar cores personalizadas",
    labelColorLabel: "Cor do rótulo",
    valueColorLabel: "Cor do valor",
    scaleInvalid: "O fator de escala deve ser um número",
    lookbackRequired: "Selecione um período de leitura",
    saveButton: "Salvar",
    cancelButton: "Cancelar",
  },
};

export const multipleTextValuesEs = {
  [moduleNameKey]: {
    entriesLabel: "Entradas",
    entryLabel: "Entrada {{ index }}",
    entryLabelPlaceholder: "Introduce la etiqueta",
    nodeLabel: "Nodo {{ index }}",
    unitLabel: "Unidad {{ index }}",
    addEntry: "Añadir entrada",
    removeEntry: "Eliminar entrada {{ index }}",
    nodeRequired: "Selecciona un nodo para cada entrada",
    labelRequired: "Cada entrada necesita una etiqueta",
    machineLabel: "Máquina",
    noMachines: "No se encontraron máquinas",
    machinesPlaceholder: "Buscar máquinas...",
    noNodes: "No se encontraron nodos",
    nodesPlaceholder: "Buscar nodos...",
    noUnits: "No se encontraron unidades",
    unitsPlaceholder: "Buscar unidades...",
    customColorsCheckbox: "Usar colores personalizados",
    labelColorLabel: "Color de la etiqueta",
    valueColorLabel: "Color del valor",
    scaleInvalid: "El factor de escala debe ser un número",
    lookbackRequired: "Seleccione un período de búsqueda",
    saveButton: "Guardar",
    cancelButton: "Cancelar",
  },
};

export const multipleTextValuesIt = {
  [moduleNameKey]: {
    entriesLabel: "Voci",
    entryLabel: "Voce {{ index }}",
    entryLabelPlaceholder: "Inserisci etichetta",
    nodeLabel: "Nodo {{ index }}",
    unitLabel: "Unità {{ index }}",
    addEntry: "Aggiungi voce",
    removeEntry: "Rimuovi voce {{ index }}",
    nodeRequired: "Seleziona un nodo per ogni voce",
    labelRequired: "Ogni voce richiede un'etichetta",
    machineLabel: "Macchina",
    noMachines: "Nessuna macchina trovata",
    machinesPlaceholder: "Cerca macchine...",
    noNodes: "Nessun nodo trovato",
    nodesPlaceholder: "Cerca nodi...",
    noUnits: "Nessuna unità trovata",
    unitsPlaceholder: "Cerca unità...",
    customColorsCheckbox: "Usa colori personalizzati",
    labelColorLabel: "Colore etichetta",
    valueColorLabel: "Colore del valore",
    scaleInvalid: "Il fattore di scala deve essere un numero",
    lookbackRequired: "Seleziona un periodo di osservazione",
    saveButton: "Salva",
    cancelButton: "Annulla",
  },
};

export const multipleTextValuesZhHans = {
  [moduleNameKey]: {
    entriesLabel: "条目",
    entryLabel: "条目 {{ index }}",
    entryLabelPlaceholder: "输入标签",
    nodeLabel: "节点 {{ index }}",
    unitLabel: "单位 {{ index }}",
    addEntry: "添加条目",
    removeEntry: "删除条目 {{ index }}",
    nodeRequired: "为每个条目选择一个节点",
    labelRequired: "每个条目都需要标签",
    machineLabel: "机器",
    noMachines: "未找到机器",
    machinesPlaceholder: "搜索机器...",
    noNodes: "未找到节点",
    nodesPlaceholder: "搜索节点...",
    noUnits: "未找到单位",
    unitsPlaceholder: "搜索单位...",
    customColorsCheckbox: "使用自定义颜色",
    labelColorLabel: "标签颜色",
    valueColorLabel: "值颜色",
    scaleInvalid: "缩放系数必须是数字",
    lookbackRequired: "选择回溯时间",
    saveButton: "保存",
    cancelButton: "取消",
  },
};

export const multipleTextValuesNl = {
  [moduleNameKey]: {
    entriesLabel: "Items",
    entryLabel: "Item {{ index }}",
    entryLabelPlaceholder: "Voer label in",
    nodeLabel: "Node {{ index }}",
    unitLabel: "Eenheid {{ index }}",
    addEntry: "Item toevoegen",
    removeEntry: "Item {{ index }} verwijderen",
    nodeRequired: "Kies een node voor elk item",
    labelRequired: "Elk item heeft een label nodig",
    machineLabel: "Machine",
    noMachines: "Geen machines gevonden",
    machinesPlaceholder: "Machines zoeken...",
    noNodes: "Geen knooppunten gevonden",
    nodesPlaceholder: "Knooppunten zoeken...",
    noUnits: "Geen eenheden gevonden",
    unitsPlaceholder: "Eenheden",
    customColorsCheckbox: "Aangepaste kleuren gebruiken",
    labelColorLabel: "Labelkleur",
    valueColorLabel: "Waardekleur",
    scaleInvalid: "Schaalfactor moet een getal zijn",
    lookbackRequired: "Kies een terugkijkperiode",
    saveButton: "Opslaan",
    cancelButton: "Annuleren",
  },
};

export const multipleTextValuesTr = {
  [moduleNameKey]: {
    entriesLabel: "Girdiler",
    entryLabel: "Girdi {{ index }}",
    entryLabelPlaceholder: "Etiket girin",
    nodeLabel: "Düğüm {{ index }}",
    unitLabel: "Birim {{ index }}",
    addEntry: "Girdi ekle",
    removeEntry: "Girdi {{ index }} sil",
    nodeRequired: "Her girdi için bir düğüm seçin",
    labelRequired: "Her girdinin bir etiketi olmalı",
    machineLabel: "Makine",
    noMachines: "Hiçbir makine bulunamadı",
    machinesPlaceholder: "Arama makineleri...",
    noNodes: "Hiçbir düğüm bulunamadı",
    nodesPlaceholder: "Düğümleri ara...",
    noUnits: "Birim bulunamadı",
    unitsPlaceholder: "Birimleri arayın...",
    customColorsCheckbox: "Özel renkler kullan",
    labelColorLabel: "Etiket rengi",
    valueColorLabel: "Değer rengi",
    scaleInvalid: "Ölçek faktörü bir sayı olmalıdır",
    lookbackRequired: "Bir yeniden inceleme seçin",
    saveButton: "Kaydetmek",
    cancelButton: "İptal etmek",
  },
};
